import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChartBarIcon, DocumentChartBarIcon } from '@heroicons/react/24/outline';

const MarketingBudgetDashboard = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Budget',
      description: 'Bütçe girişi ve yönetimi',
      icon: ChartBarIcon,
      path: '/marketing-budget/budget',
      color: 'bg-blue-500',
      hoverColor: 'hover:bg-blue-600'
    },
    {
      title: 'Reports',
      description: 'Bütçe raporları ve analizler',
      icon: DocumentChartBarIcon,
      path: '/marketing-budget/reports',
      color: 'bg-green-500',
      hoverColor: 'hover:bg-green-600'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Marketing Budget Management
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Marketing bütçe yönetimi ve raporlama sistemi
          </p>
        </div>

        {/* Menu Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <div
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`${item.color} ${item.hoverColor} rounded-lg p-6 cursor-pointer transition-all duration-200 transform hover:scale-105 shadow-lg`}
              >
                <div className="flex items-center">
                  <div className="flex-shrink-0">
                    <Icon className="h-8 w-8 text-white" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-white">
                      {item.title}
                    </h3>
                    <p className="text-blue-100">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Quick Stats */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Toplam Bütçe
            </h3>
            <p className="text-2xl font-bold text-blue-600 dark:text-blue-400">
              ₺0
            </p>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Aktif Projeler
            </h3>
            <p className="text-2xl font-bold text-green-600 dark:text-green-400">
              0
            </p>
          </div>
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Bu Ay Harcanan
            </h3>
            <p className="text-2xl font-bold text-red-600 dark:text-red-400">
              ₺0
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingBudgetDashboard;
